var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("预警配置")])]),_c('p',[_vm._v("预警配置页面内容")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }